
export const AVAILABLE_HOUR_INFO = "Filtered by billing date."